/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PartNumberChangeDetailSolutionTrialComponent} from './part-number-change-detail-solution-trial.component';
import {
    PartNumberChangesRejectMotivationModule
} from '../../part-number-changes-old-credentials/part-number-changes-reject-motivation/part-number-changes-reject-motivation.module';
import {
    PartNumberChangesNewPartNumberModule
} from '../part-number-changes-new-part-number/part-number-changes-new-part-number.module';
import {InputModule} from '../../../shared/input/input.module';
import {PipesModule} from '../../../shared/pipes/pipes.module';
import {
    PartNumberChangesAdditionalInputModule
} from '../../shared/part-number-changes-additional-input/part-number-changes-additional-input.module';

@NgModule({
    declarations: [PartNumberChangeDetailSolutionTrialComponent],
    imports: [
        CommonModule,
        InputModule,
        PipesModule,
        CommonModule,
        InputModule,
        PipesModule,
        PartNumberChangesAdditionalInputModule,
        PartNumberChangesRejectMotivationModule,
        PartNumberChangesNewPartNumberModule
    ],
    exports: [PartNumberChangeDetailSolutionTrialComponent]
})
export class PartNumberChangeDetailSolutionTrialModule {
}
